import { cn } from "@tcg/ui";
import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useChangeLanguage } from "@/hooks/useChangeLanguage";
import { isPosLocale, POS_LOCALE_NAMES, POS_LOCALES, type PosLocale } from "@/i18n";

/**
 * The language picker on every screen (owner 2026-10-05 "หน้า POS ขอ Multilang", design/05 §3):
 * top bar, pairing screen and PIN screen — one tap, each language written in its own words.
 */
export function LanguagePicker({
  className,
  onChange,
}: {
  className?: string;
  /** Called after the switch (the PIN screen keeps the choice for whoever signs in next). */
  onChange?: (locale: PosLocale) => void;
}) {
  const { t, i18n } = useTranslation();
  const change = useChangeLanguage();
  const current = isPosLocale(i18n.resolvedLanguage) ? i18n.resolvedLanguage : "ja";
  return (
    <label
      className={cn(
        "flex min-h-10 items-center gap-1 rounded-md border bg-background pl-2",
        className,
      )}
    >
      <Languages aria-hidden className="size-4 shrink-0" />
      <select
        aria-label={t("app.language")}
        value={current}
        onChange={(e) => {
          const next = e.target.value;
          if (isPosLocale(next)) {
            change(next);
            onChange?.(next);
          }
        }}
        className="min-h-10 rounded-md bg-transparent pr-2 text-base"
      >
        {POS_LOCALES.map((code) => (
          <option key={code} value={code} lang={code}>
            {POS_LOCALE_NAMES[code]}
          </option>
        ))}
      </select>
    </label>
  );
}
